import { useEffect, useState } from "react";
import type { RootState } from "@/redux/store";
import { useDispatch, useSelector } from "react-redux";

import { useAuth } from "@/context/AuthContext";
import ModalWrapper from "@/components/shared/ModalWrapper/ModalWrapper";
import LoadingModal from "@/components/shared/LoadingModal/LoadingModal";
import OwnProfileModal from "../OwnProfileModal";
import ConnectedProfileModal from "../ConnectedProfileModal";
import UnConnectedProfileModal from "../UnConnectedProfileModal";
import useFriendRequestModalHook from "@/helpers/useFriendRequestModalHook";
import {
  addProfileModalUid,
  removeProfileModalUid,
} from "../../../../redux/slices/profileModalUidSlice";

export default function ProfileModalHandler(props: {
  uid: string | undefined;
  elementName: "profileModal";
  peerStorySlug?: string;
}) {
  const { user } = useAuth();
  const dispatch = useDispatch();

  const [ownProfile, setOwnProfile] = useState<boolean | null>(null);
  const [isConnected, setIsConnected] = useState<boolean>(false);

  const userState = useSelector((state: RootState) => state.user);

  useEffect(() => {
    if (props.uid) {
      if (props.uid !== user?.uid) {
        setOwnProfile(false);
        if (userState.friendUidList.includes(props.uid as string)) {
          setIsConnected(true);
        } else {
          setIsConnected(false);
        }
      } else if (props.uid === user?.uid) {
        setOwnProfile(true);
      } else {
        setOwnProfile(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.uid, user?.uid, userState.friendUidList.length]);

  useEffect(() => {
    //keeps track of the uids
    if (props.uid) {
      dispatch(addProfileModalUid(props.uid));
    }

    return () => {
      dispatch(removeProfileModalUid());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.uid]);

  useFriendRequestModalHook({ uid: props.uid });

  if (ownProfile === null) {
    return <LoadingModal elementName="LoadingModal" />;
  } else {
    if (ownProfile === true) {
      return (
        <ModalWrapper title="" noLine noHeader>
          <OwnProfileModal />
        </ModalWrapper>
      );
    } else {
      if (isConnected && props.uid) {
        return (
          <ModalWrapper title="" noLine noHeader>
            <ConnectedProfileModal
              peerStorySlug={props.peerStorySlug}
              uid={props.uid}
            />
          </ModalWrapper>
        );
      } else {
        if (props.uid) {
          return (
            <ModalWrapper title="" noLine noHeader>
              <UnConnectedProfileModal uid={props.uid} />
            </ModalWrapper>
          );
        } else {
          return <></>;
        }
      }
    }
  }
}
